// JavaScript to make text collapsible after the first paragraph
document.addEventListener("DOMContentLoaded", () => {
    // Select all sections with the specified class for collapsible text
    const collapsibleSections = document.querySelectorAll(".collapsible-section");

    collapsibleSections.forEach((section) => {
        const paragraphs = section.querySelectorAll("p");

        if (paragraphs.length > 1) {
            // Wrap the additional paragraphs in a collapsible container
            const collapsibleContainer = document.createElement("div");
            collapsibleContainer.classList.add("collapsible-content-custom");

            // Move all paragraphs except the first into the collapsible container
            for (let i = 1; i < paragraphs.length; i++) {
                collapsibleContainer.appendChild(paragraphs[i]);
            }

            section.appendChild(collapsibleContainer);

            // Add a toggle link
            const toggleLink = document.createElement("a");
            toggleLink.href = "#";
            toggleLink.textContent = "+ Mehr anzeigen";
            toggleLink.classList.add("collapsible-toggle-custom");

            toggleLink.addEventListener("click", (event) => {
                event.preventDefault();
                const isExpanded = collapsibleContainer.classList.toggle("expanded");
                toggleLink.textContent = isExpanded ? "− Weniger anzeigen" : "+ Mehr anzeigen";
            });

            section.appendChild(toggleLink);
        }
    });
});